import { smoothScroll } from "./smoothScroll";

export const animateNavigationToNewPath = (navigate, newPath) => {
  const navigationDelay = 0;

  setTimeout(() => {
    navigate(newPath);
    smoothScroll();
  }, navigationDelay)
};

export const getFilteredQueryString = (queryString) => {
  const removeEmptyValuesReducer = (accumulator, [key, value]) => {
    if (typeof (value) !== "undefined") {
      accumulator[key] = value;
    }
    return accumulator;
  };

  return Object.entries(queryString).reduce(removeEmptyValuesReducer, {});
};

export const setupLoanRoute = ({shouldRouteBeActive, navigateTo}) => ({
  shouldRouteBeActive,
  navigateTo,
});